import { EstateClearVaultExportService } from '/@/modules/estate/services/EstateClearVaultExportService';
import { ExportType } from '/@/modules/export/constants/ExportType';
import { LiquidationLetterExportService } from '/@/modules/asset/services/LiquidationLetterExportService';
import { EstateClearEstateExportService } from '/@/modules/estate/services/EstateClearEstateExportService';
import { EstateDistributionPlanExportService } from '/@/modules/estatedistribution/services/EstateDistributionPlanExportService';
import { BeneficiaryFinancialInformationService } from '/@/modules/estatedistribution/services/BeneficiaryFinancialInformationService';
import { PurchaseSummaryExportService } from '/@/modules/estate/services/PurchaseSummaryExportService';
import { NotifyCreditorsInstructionsExportService } from '/@/modules/estate/services/NotifyCreditorsInstructionsExportService';
import { CaliforniaNotifyBeneficiariesInstructionsExportService } from '/@/modules/estate/services/CaliforniaNotifyBeneficiariesInstructionsExportService';
import { WillsNoticeSearchInstructionsExportService } from '@/modules/estate/services/WillsNoticeSearchInstructionsExportService';
import { DiagnosticToolResultsPageExportService } from '@/modules/typeform/services/DiagnosticToolResultsPageExportService';
import { ClearVaultFinalReportExportService } from '@/modules/estate/services/ClearVaultFinalReportExportService';
import { ExportTypeBaseService } from '@/modules/export/services/ExportTypeBaseService';
import { CainLamarreReceiptsSummaryExportService } from '@/modules/estate/services/CainLamarreReceiptsSummaryExportService';
import { FinalTaxesSummaryExportService } from '@/modules/tax/services/FinalTaxesSummaryExportService';

export class ExportViewerServiceFactory {
  static build(
    type: ExportType,
    resourceId: string | number,
    params: Params = {}
  ): typeof ExportTypeBaseService {
    const classType: typeof ExportTypeBaseService = ExportViewerServiceFactory.getClass(type);
    // @ts-ignore
    return new classType({
      type,
      resourceId,
      params
    });
  }

  /**
   * @param type
   * @return {ExportTypeBaseService}
   */
  static getClass(type: ExportType): typeof ExportTypeBaseService {
    switch (type) {
      case ExportType.BENEFICIARY_FINANCIAL_INFORMATION:
        return BeneficiaryFinancialInformationService;
      case ExportType.CAIN_LAMARRE_RECEIPTS_SUMMARY:
        return CainLamarreReceiptsSummaryExportService;
      case ExportType.CALIFORNIA_NOTIFY_BENEFICIARIES_INSTRUCTIONS:
        return CaliforniaNotifyBeneficiariesInstructionsExportService;
      case ExportType.CLEAR_VAULT_SUMMARY:
        return EstateClearVaultExportService;
      case ExportType.CLEAR_ESTATE_SUMMARY:
        return EstateClearEstateExportService;
      case ExportType.CLEAR_VAULT_FINAL_REPORT:
        return ClearVaultFinalReportExportService;
      case ExportType.DIAGNOSTIC_TOOL_RESULTS_PAGE:
        return DiagnosticToolResultsPageExportService;
      case ExportType.EXECUTOR_RESIDUAL_BENEFICIARIES_DISTRIBUTION_PLAN:
      case ExportType.SPECIFIC_BENEFICIARY_DISTRIBUTION_PLAN:
        return EstateDistributionPlanExportService;
      case ExportType.FINAL_TAXES_SUMMARY:
        return FinalTaxesSummaryExportService;
      case ExportType.LIQUIDATION_LETTER:
        return LiquidationLetterExportService;
      case ExportType.NOTIFY_CREDITORS_INSTRUCTIONS:
        return NotifyCreditorsInstructionsExportService;
      case ExportType.PURCHASE_SUMMARY:
        return PurchaseSummaryExportService;
      case ExportType.WILLS_NOTICE_SEARCH_INSTRUCTIONS:
        return WillsNoticeSearchInstructionsExportService;
      default:
        throw new Error(`Unhandled export service type ${type}`);
    }
  }
}
